import { isNullOrUndefined } from "util";
import { Message } from "element-ui";
import store from '../store/index.js'
//根据运行模式，增加前缀
const baseUrl = process.env.BASE_API;
const paramsFormat = params => {
  let count = 0;
  let paramsUrl = "?";
  try {
    for (let key in params) {
      paramsUrl = paramsUrl + key + "=" + encodeURI(params[key]) + "&";
      count++;
    }
    let temp = paramsUrl;
    if (count > 0) {
      if (temp.charAt(paramsUrl.length - 1) == "&") {
        return paramsUrl.substring(0, paramsUrl.length - 1);
      } else {
        return paramsUrl;
      }
    } else {
      return "";
    }
  } catch (error) {
    console.error("文件下载参数格式错误！");
    console.error(error);
    return null;
  }
};
const fileDownload = (url, params) => {
  if (isNullOrUndefined(params)) {
    window.open(baseUrl + url);
  } else {
    let paramsUrl = paramsFormat(params);
    if (isNullOrUndefined(paramsUrl)) {
      Message({
        message: "文件下载失败，请联系管理员！",
        type: "error",
        duration: 5 * 1000
      });
    } else {
      let moduleUrl = store.state.moduleUrl
      window.open(baseUrl + moduleUrl + url + paramsUrl);
    }
  }
};
export default { baseUrl, fileDownload };



// WEBPACK FOOTER //
// ./src/common/fileDownload.js